import { Globe, MapPin, Handshake } from "lucide-react";

const FEATURES = [
  {
    icon: MapPin,
    title: "Strategic Position",
    text: "Direct access to North American, Latin American, and Caribbean markets.",
  },
  {
    icon: Globe,
    title: "Trade Relationships",
    text: "Established agreements supporting import, export, and regional commerce.",
  },
  {
    icon: Handshake,
    title: "Business-Ready Environment",
    text: "Infrastructure and operational frameworks designed for international companies.",
  },
];

export default function BusinessContext() {
  return (
    <section
      data-testid="business-context-section"
      className="bg-[#F8F9FA] py-20 lg:py-28"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="max-w-2xl mb-14">
          <span
            className="text-xs font-semibold tracking-[0.2em] uppercase text-[#D49A38] block"
            style={{ fontFamily: "Manrope, sans-serif" }}
            data-testid="context-overline"
          >
            Business Context
          </span>
          <div className="w-12 h-[2px] bg-[#D49A38] mt-4 mb-6" />

          <h2
            className="text-3xl sm:text-4xl lg:text-5xl font-bold text-[#182649] tracking-tight leading-[1.1] uppercase"
            style={{ fontFamily: "Outfit, sans-serif" }}
            data-testid="context-headline"
          >
            Designed for <span className="text-[#D49A38]">regional</span> and global activity
          </h2>

          <p
            className="mt-5 text-base md:text-lg text-[#4A5568] leading-relaxed"
            style={{ fontFamily: "Manrope, sans-serif" }}
            data-testid="context-text"
          >
            Jamaica's position and trade relationships support companies serving the Caribbean and international markets.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {FEATURES.map((f) => (
            <div
              key={f.title}
              className="bg-white border border-[#E2E8F0] rounded-md p-8 hover:shadow-md transition-shadow duration-300"
              data-testid={`context-feature-${f.title.toLowerCase().replace(/\s+/g, "-")}`}
            >
              <div className="w-12 h-12 rounded-full bg-[#182649] flex items-center justify-center mb-5">
                <f.icon className="h-5 w-5 text-[#D49A38]" />
              </div>
              <h3
                className="text-lg font-bold text-[#182649] mb-2"
                style={{ fontFamily: "Outfit, sans-serif" }}
              >
                {f.title}
              </h3>
              <p
                className="text-sm text-[#4A5568] leading-relaxed"
                style={{ fontFamily: "Manrope, sans-serif" }}
              >
                {f.text}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
